module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Wood_MockedUp.f4e215dc.jpg";